import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=a667a6f2&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=a667a6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a667a6f2",
  null
  
)

export default component.exports